var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"saving"},[_c('img',{attrs:{"src":require("@/assets/icons/spinner.svg")}}),_c('p',{staticClass:"text--bold",class:_vm.textClass},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }